/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { FacilityTypeEnum, TemplateContentTypeEnum, TemplateTypeEnum } from "medicalsystem-shared";

/**
 * Sexual Orientation and Gender Identity (SOGI) dropdown options.
 * Provides inclusive list of gender identities and sexual orientations.
 */
export const sogiListOptions = [
  { value: "Agender", label: "Agender" },
  { value: "Bigender", label: "Bigender" },
  { value: "Demiboy", label: "Demiboy" },
  { value: "Demigirl", label: "Demigirl" },
  { value: "Female", label: "Female" },
  { value: "Gender-fluid", label: "Gender-fluid" },
  { value: "Genderqueer", label: "Genderqueer" },
  { value: "Male", label: "Male" },
  { value: "Non-binary", label: "Non-binary" },
  { value: "Transgender", label: "Transgender" },
  { value: "Two-spirit", label: "Two-spirit" },
  { value: "Asexual", label: "Asexual" },
  { value: "Bisexual", label: "Bisexual" },
  { value: "Gay", label: "Gay" },
  { value: "Lesbian", label: "Lesbian" },
  { value: "Pansexual", label: "Pansexual" },
  { value: "Straight", label: "Straight" },
  { value: "Queer", label: "Queer" },
];

/**
 * Office visit status options for tracking patient flow.
 * Used in office visit forms to indicate current patient status.
 */
export const visitOfficeListOptions = [
  { value: "Done", label: "Done" },
  { value: "Injection Needed", label: "Injection Needed" },
  { value: "LABS", label: "LABS" },
  { value: "Ready to be seen", label: "Ready to be seen" },
  { value: "Triage", label: "Triage" },
  { value: "Waiting Room", label: "Waiting Room" },
];

export const visitStatusListOptions = [
  { value: "N/S", label: "N/S" },
  { value: "ARR", label: "ARR" },
  { value: "CHK", label: "CHK" },
  { value: "LAB", label: "LAB" },
  { value: "CANC", label: "CANC" },
];

export const visitTypeListOptions = [
  { value: "Nurse Visit", label: "Nurse Visit" },
  { value: "LAB", label: "LAB" },
  { value: "F/U", label: "F/U" },
  { value: "ESTPT", label: "ESTPT" },
  { value: "Walk-in", label: "Walk-in" },
];

export const templateTypeOptions = [
  { value: TemplateTypeEnum.HPI, label: "HPI" },
  { value: TemplateTypeEnum.PRESCRIPTION, label: "Prescription" },
];

export const TemplateContentTypeOption = [
  { value: TemplateContentTypeEnum.TEXT_HTML, label: "Text/Html" },
  { value: TemplateContentTypeEnum.JSON, label: "Json" },
  { value: TemplateContentTypeEnum.OTHER, label: "Other" },
];
